var FormFilterModule = /** @class */ (function () {
    function FormFilterModule() {
    }
    return FormFilterModule;
}());
export { FormFilterModule };
